/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_Tab_DataInputs */

const en_ui_settings_tab_data = /** @type {(inputs: Ui_Settings_Tab_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data Management`)
};

const de_ui_settings_tab_data = /** @type {(inputs: Ui_Settings_Tab_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenverwaltung`)
};

/**
* | output |
* | --- |
* | "Data Management" |
*
* @param {Ui_Settings_Tab_DataInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_tab_data = /** @type {((inputs?: Ui_Settings_Tab_DataInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_Tab_DataInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_tab_data(inputs)
	return de_ui_settings_tab_data(inputs)
});